<template>
  <div class="home">
    <div>
      <el-carousel arrow="never" height="440px">
        <el-carousel-item v-for="(item,index) in bannerArr" :key="index" >
          <img v-lazy="item.img" style="width: 100%; height:100%" :alt="item.name" @click="swiperClick(item)">
        </el-carousel-item>
      </el-carousel>

    </div>

    <div class="shop-container">
		
		

      <div class="img-wrap">
        <div class="img-wrap-item" v-for="(item, index) in homeMini" :key="index" @click="swiperClick(item)">
          <img :src="item.img" alt="">
        </div>
      </div>
	  
	  <!-- 我们的优势 -->
      <div class="heard-con">
        <div class="heard-con-item" v-for="(item, index) in advantage" :key="index" @click="swiperClick(item)">
			<img :src="item.img" alt="">
        </div>
      </div>
	  
      <template>
        <!-- {{loftData}} -->
        <div v-for="(listItem,index) in loftData" :key="index">
          <product-loft
            :headTitle="listItem.name"
            :list="listItem.goods"
            :advLeft="listItem.adv.left"
            :keyword="listItem.keyword"
            nums="8"
          ></product-loft>
          <one-shop :shopImg="listItem.adv.bottom"></one-shop>
        </div>
      </template>

      <class-loft />
	  
	  <!-- 六大荣誉 -->
      <div class="footer-con">
        <div class="footer-con-item" v-for="(item, index) in honour" :key="index" @click="swiperClick(item)">
          <img :src="item.img" alt="">
        </div>
      </div>
	  
	  <!-- 媒体链接 -->
      <div class="footer-link" v-if="shareList !==undefined && shareList != null  && shareList.length > 0">
		<div class="footer-link-title">
			<div class="footer-link-title-item">
			  <span>Contact Us</span>
			</div>
			<div class="footer-link-title-item">
			  <span>Store</span>
			</div>
			<div class="footer-link-title-item">
			  <span>Follow Us</span>
			</div>
			<div class="footer-link-title-item">
			  <span>Payment</span>
			</div>
		</div>
		<div class="footer-link-conten">
			<div class="footer-link-conten-item" v-for="(item, index) in shareList" :key="index" @click="goShare(item)">
			  <img :src="item.cover_url">
			</div>
		</div>
      </div>
	  
    </div>
    <ScrollToTop></ScrollToTop>
	
	
	
  </div>
</template>

<script>
// @ is an alias to /src

import AllClassify from "@/components/common/AllClassify.vue";
import NewShopList from "@/components/home/NewShopList.vue";
import ProductLoft from "@/components/home/ProductLoft.vue";
import OneShop from "@/components/home/OneShop.vue";
import ScrollToTop from "@/components/common/ScrollToTop.vue";

import ClassLoft from "@/components/layout/ClassLoft.vue";

import {apiBaseUrl} from '@/config/env.js'

import {checkPlate} from '@/utils/index.js'
export default {
  data() {
    return {
      allClassifyData: [], //所有商品分类
      bannerArr: [],
      homeMini: [], // 分类小图
      newsShopList: [], //新品上市,
      loftData: [],
      couponList: [], //优惠券列表
      centerDialogVisible: false,
      qrCodeShow: false,
      nowTime: '', // 现在时间戳
      banner: '',
	  advantage:[] ,  //六大优势图
	  honour:[]    ,  //六大荣誉
	  shareList:[],  //底部分享链接
    };
  },
  name: "Home",
  components: {
    AllClassify,
    NewShopList,
    ProductLoft,
    // ReCommend,
    OneShop,
    ScrollToTop,
    ClassLoft
  },
  beforeRouteEnter (to, from, next){
    if(checkPlate()) {
       //window.location.href =  '/wap/pagelogin/login/index1' + window.location.search
	   window.location.href =  '/wap' + window.location.search
      return
    }
    console.log('vm', to)

  next(vm => {

    // 通过 `vm` 访问组件实例,将值传入fromPath
    vm.fromPath = from.path
    // console.log("path",vm.fromPath);
    if(vm.fromPath == "/login"){
      // vm.centerDialogVisible=true
    }
  })
},
  mounted() {
    this.getHomeSlider();
    this.getRecomendList();
    this.getLoftData();
    this.getCouponList();
    this.nowTime = new Date().getTime()
    
    this.banner = apiBaseUrl + 'static/images/pcstatic/banner.png?' + this.nowTime

  // console.log('this.nowTime', this.nowTime, localStorage.getItem('endTime'))
    if(this.nowTime < localStorage.getItem('endTime')) {
      this.qrCodeShow = false
    } else {
      this.qrCodeShow = true
    }
  },
  methods: {
    closeDia() {
      this.qrCodeShow = false
      let endTime = new Date().getTime() + 7 * 86400000
      localStorage.setItem('endTime', endTime)
    },

    change(val) {
      this.$i18n.locale = val
    },
    // /点击
    swiperClick(v) {
      // type 1 url 直接跳转
      // 2 商品
      //  3 文章
      // 4  文章分类
      // 5 智能表单
    // window.open('https://www.baidu.com','_blank')
      if(v.type == 1) {
        window.open(v.val,'_blank')
        return
      }

      if(v.type == 2) {
        this.$router.push({
          path: `detail/${v.val}`,
        })
        return
      }
    },
	//分享链接
	goShare(v) {
			window.open(v.url,'_blank')
	},
    getLoftData() {
      this.$api.homeLoftData().then(res => {
        if (res.status) {
          // console.log('loftData', res.data)
          this.loftData = res.data;
        }
      });
    },
    //获取首页banner轮播
    getHomeSlider() {
      let data={
        code: "pc_home_slide"
      }
      this.$api.slider(data).then(res => {
        if (res.status) {
          this.bannerArr = res.data.list;
        }
      });

      // 分类小图
      this.$api.slider({
        code: 'pc_home_goods_class_mini_1'
      }).then(res => {
        if (res.status) {
          // console.log('res----', res)
          this.homeMini = res.data.list;
        }
      });

      // 我们的优势图
      this.$api.slider({
        code: 'pc_home_advantage'
      }).then(res => {
        if (res.status) {
          //console.log('advantage----', res.data.list)
          this.advantage = res.data.list;
        }
      });
	  
      // 六大荣誉
      this.$api.slider({
        code: 'pc_home_honour'
      }).then(res => {
        if (res.status) {
          //console.log('honour----', res.data.list)
          this.honour = res.data.list;
        }
      });
	  
	  //获取底部分享链接
	  this.$api.commonGeturl({}).then(res => {
		if(res.status) {
			//console.log('honour----', res.data)
			this.shareList = res.data;
		}
	  })

    },
    //获取新品上市
    getRecomendList() {
      let data = {
        where: JSON.stringify({
          recommend: 1
        })
      };
      let option = {
        page: 1,
        limit: 10
      };
      let params = Object.assign(data, option);
      this.$api.goodsList(params).then(res => {
        if (res.status) {
          this.newsShopList = res.data.list;
        }
      });
    },
    // 获取商户优惠券信息
    getCouponList() {
      this.$api.couponList().then(res => {
        if (res.status) {
          this.couponList = res.data;
          // console.log('couponList', this.couponList)
          if(res.data.length>0){
            this.centerDialogVisible=true
          }
        }
      });
    },
    //领取优惠券
    userGetCoupon(id) {
      this.$api.getCoupon({ promotion_id: id }).then(res => {
        if(res.status){
          this.$msg(res.msg)
        }else{
          this.$msg(res.msg,'warning')
        }
        // this.centerDialogVisible=false;
      });
    }
  },
  deactivated(){
    this.centerDialogVisible=false;
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.adve{
  width: 1226px;
  margin: 20px 0;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.nav-wrap {
  width: 100%;
  position: relative;
  height: 440px;

  .banner-list {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 440px;
    z-index: 10;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.banner {
  width: 100%;
  height: 376px;
}
.coupon-list {
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
}

.coupon-wrap:nth-child(3n) {
  margin-right: auto;
}

.img-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  &-item {
    width: 305px;
    height: 180px;
    &:first-child {
      width: 220px;
    }
  }
}

.heard-con {
  display: flex;
  &-item {
    
    width: 100%;
    // height: 140px;
    color: #999;
    display: flex;
    flex-direction: column;
    margin-top: 40px;
    .icon {
      width: 63px;
      height: 63px;
      margin-bottom: 20px;
      display: block;
      overflow: hidden;
      margin: 0 auto 20px;
      cursor: pointer;
      background: url('~@/assets/images/home/banner.png') no-repeat;
      &.quality {
        background-position: -64px 0;
      }
      &.back {
        background-position: -128px 0;
      }
      &.depot {
        background-position: -190px 0;
      }
      &.consignment {
        background-position: -253px 0;
      }
      &.packaging {
        background-position: -316px 0;
      }
      &.confide {
        background-position: -379px 0;
      }
    }
    .text {
      color: #000;
      font-size: 16px;
      height: 24px;
      line-height: 20px;
      overflow: hidden;
      display: block;
      cursor: pointer;
      font-weight: bold;
      text-align: center;
    }
  }
}

.footer-con {
  display: flex;
  &-item {
    
    width: 100%;
    // height: 140px;
    color: #999;
    display: flex;
    flex-direction: column;
    margin-top: 0px;
    .icon {
      width: 63px;
      height: 63px;
      margin-bottom: 20px;
      display: block;
      overflow: hidden;
      margin: 0 auto 20px;
      cursor: pointer;
      background: url('~@/assets/images/home/banner.png') no-repeat;
      &.quality {
        background-position: -64px 0;
      }
      &.back {
        background-position: -128px 0;
      }
      &.depot {
        background-position: -190px 0;
      }
      &.consignment {
        background-position: -253px 0;
      }
      &.packaging {
        background-position: -316px 0;
      }
      &.confide {
        background-position: -379px 0;
      }
    }
    .text {
      color: #000;
      font-size: 16px;
      height: 24px;
      line-height: 20px;
      overflow: hidden;
      display: block;
      cursor: pointer;
      font-weight: bold;
      text-align: center;
    }
  }
}

.footer-link {
	justify-content: space-between;
	align-items: center;
	margin-top: 10px;
	background-color:#ffffff;
	img{
		width:175px;
		height:175px;
	}
	.footer-link-title{
		display: flex;
		span{
			display: block;
			height: 60px;
			text-align: center;
			font-size: 20px;
			line-height: 70px;
			font-weight: bold;
		}
		&-item {
			width: 175px;
			height: 60px;
			&:first-child {
			  width: 181px;
			}
			&:nth-child(3) {
			  width: 700px;
			}
			&:last-child {
			  //width: 700px;
			}
		}
	}
	.footer-link-conten{
		display: flex;
		&-item {
			width: 175px;
			height: 175px;
		}
		&-item :hover{
			cursor:pointer;
		}
	}
}
</style>
